import React from 'react';
import {
    Flex,
    Box,
    IconButton,
    Button,
    Text,
    useDisclosure,
    VStack,
    HStack,
    Link as ChakraLink,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Link, NavLink } from 'react-router-dom';

import logo from "../icons/bondlogo.png"
import ProductAlert from './ProductAlert';

const Navbar = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <Box style={{ background: "linear-gradient(90deg, rgb(0 0 0) 0%, rgb(162 89 211) 100%)" }}
            px={4}
            boxShadow="rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px"
            position={"fixed"}
            width={"full"}
            borderRadius={"12px"}
        >
            <ProductAlert />
            <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
                <IconButton
                    size={'md'}
                    icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                    aria-label={'Open Menu'}
                    display={{ md: 'none' }}
                    onClick={isOpen ? onClose : onOpen}
                />
                <HStack spacing={8} alignItems={'center'}>
                    <Box>
                        <Link to="/">
                            <Text color={'white'}>
                                <img src={logo} alt="logo" width="94px" />
                            </Text>
                        </Link>
                    </Box>
                    <HStack
                        as={'nav'}
                        spacing={4}
                        display={{ base: 'none', md: 'flex' }}
                    >
                        <ChakraLink as={Link} to="/mentors" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Mentors
                        </ChakraLink>
                        <ChakraLink as={Link} to="/parents" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Parents
                        </ChakraLink>
                        <ChakraLink as={Link} to="/friends" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Friends
                        </ChakraLink>
                        <ChakraLink as={Link} to="/loved-ones" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Loved Ones
                        </ChakraLink>
                    </HStack>
                </HStack>
                {/* 
                <Flex alignItems={'center'} gap="12px">
                    <NavLink to="/PhoneLoginPage">
                        <Button
                            display={{ base: 'none', md: 'inline-flex' }}
                            fontSize={'sm'}
                            fontWeight={600}
                            color={'black'}
                            bg={'pink.400'}
                            href={'#'}
                            _hover={{
                                bg: 'pink.300',
                            }}
                        >
                            Log In
                        </Button>
                    </NavLink>

                    <NavLink to="/SignupPage">
                        <Button
                            display={{ base: 'none', md: 'inline-flex' }}
                            fontSize={'sm'}
                            fontWeight={600}
                            color={'black'}
                            bg={'pink.400'}
                            href={'/SignupPage'}
                            _hover={{
                                bg: 'pink.300',
                            }}
                        >
                            Sign Up
                        </Button>
                    </NavLink>
                </Flex> */}
            </Flex>
            {isOpen ? (
                <Box pb={4} display={{ base: 'flex', md: 'none' }} justifyContent={"center"} alignItems={"center"} gap="26px" flexDirection={"column"} >
                    <VStack
                        as={'nav'}
                        spacing={9}
                        display={{ base: 'flex', md: 'none' }}
                        mt="18px"
                        alignItems={'center'}
                    >
                        <ChakraLink as={Link} to="/mentors" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Mentors
                        </ChakraLink>
                        <ChakraLink as={Link} to="/parents" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Parents
                        </ChakraLink>
                        <ChakraLink as={Link} to="/friends" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Friends
                        </ChakraLink>
                        <ChakraLink as={Link} to="/loved-ones" color={'white'} style={{ fontWeight: 600, fontSize: '21px', fontStyle: 'oblique' }}>
                            Loved Ones
                        </ChakraLink>

                    </VStack>
                    {/* <Flex alignItems={'center'} gap="12px">
                        <NavLink to="/PhoneLoginPage">
                            <Button
                                display={{ base: 'inline-flex', md: 'inline-flex' }}
                                fontSize={'sm'}
                                fontWeight={600}
                                color={'black'}
                                bg={'pink.400'}
                                href={'/PhoneLoginPage'}
                                _hover={{
                                    bg: 'pink.300',
                                }}
                            >
                                Log In
                            </Button>
                        </NavLink>

                        <NavLink to="/SignupPage">
                            <Button
                                display={{ base: 'inline-flex', md: 'inline-flex' }}
                                fontSize={'sm'}
                                fontWeight={600}
                                color={'black'}
                                bg={'pink.400'}
                                href={'/SignupPage'}
                                _hover={{
                                    bg: 'pink.300',
                                }}
                            >
                                Sign Up
                            </Button>
                        </NavLink>
                    </Flex> */}


                </Box>
            ) : null}
        </Box>
    );
};

export default Navbar;
